import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
import { Button } from '@mui/material';
import { Error } from './Error';
import { RELOAD, WE_HAVE_A_LITTLE_PROBLEM } from './constants';

class ErrorBoundary extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      error: null,
    };
  }

  componentDidCatch(error, info) {
    Sentry.withScope(scope => {
      scope.setExtras(info);
      this.setState({ error });
    });
  }

  onReloadClick = () => {
    window.location.reload();
  };

  render() {
    const { component: Component, children, ...props } = this.props;

    if (this.state.error) {
      return (
        <Sentry.ErrorBoundary
          fallback={
            <Component
              title={WE_HAVE_A_LITTLE_PROBLEM}
              onButtonClick={this.onReloadClick}
              actionContent={() => (
                <Button variant={'contained'} onClick={this.onReloadClick}>
                  {RELOAD}
                </Button>
              )}
              sx={{ height: '100vh' }}
              {...props}
            />
          }
        >
          {children}
        </Sentry.ErrorBoundary>
      );
    }

    return children;
  }
}

ErrorBoundary.defaultProps = {
  component: Error,
};

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  component: PropTypes.elementType.isRequired,
};

export default ErrorBoundary;
